export default __webpack_public_path__ + "static/media/postal-code.52a9c1f5.svg";